import {
  LOAD_SERVICE_FAVORITE_STATUS_SUCCESS,
  CHANGE_SERVICE_FAVORITE_STATUS_SUCCESS
} from '../constants';

const initialState = {
  inFavorite: false
};

const serviceFavoriteStatus = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_SERVICE_FAVORITE_STATUS_SUCCESS:
    case CHANGE_SERVICE_FAVORITE_STATUS_SUCCESS:
      return {
        ...state,
        inFavorite: action.payload
      };
    default:
      return state;
  }
};

export default serviceFavoriteStatus;
